import { useDispatch } from 'react-redux'
import { RefObject } from 'react'
import { useDrop } from 'react-dnd'

import { ItemTypes } from 'data/constants'
import { moveNotesTo } from 'data/notes/actions'
import { formatDateToDefaultPosition } from '../../helpers/formatDateToDefaultPosition'
import { NoteDragItem } from '../Note/useNoteDragAndDrop'

export default function useChannelDrop(
  channelId: string,
  canCreateNote: boolean,
  ref: RefObject<any>
) {
  const dispatch = useDispatch()

  const [{ isDragOver }, drop] = useDrop<
    NoteDragItem,
    void,
    { isDragOver: boolean }
  >({
    accept: ItemTypes.NOTE,

    collect(monitor) {
      return {
        isDragOver: monitor.isOver({ shallow: true }),
      }
    },

    drop(dragItem, monitor) {
      // Prevent dropping on parent in a nested dnd environ
      if (!monitor.isOver({ shallow: true }) || !canCreateNote) {
        return
      }

      dispatch(
        moveNotesTo({
          noteIds: [dragItem.noteId],
          channelId,
          position: formatDateToDefaultPosition(),
          analyticsSource: 'dnd',
          toaster: false,
        })
      )
    },
  })

  drop(ref)

  const hoverZone = isDragOver && canCreateNote ? 'middle' : null

  return { isDragOver, hoverZone }
}
